import { META_TEMPLATES } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  templates: [],
  whatsappBot: [] as any[],
  selectedTemplateStatus: null,
};

const metaTemplatesSlice = createSlice({
  name: META_TEMPLATES,
  initialState,
  reducers: {
    setMetaTemplates: (state, { payload }) => {
      state.templates = payload.templates;
    },
    setWhatsappBot: (state, {payload}) => {
        const existingBotIndex = state.whatsappBot.findIndex(bot => bot.flowId === payload.flowId);
        if(existingBotIndex !== -1) {
            state.whatsappBot = state.whatsappBot.map((bot, index) =>
                index === existingBotIndex ? {...bot, ...payload} : bot
            );
        }else {
            state.whatsappBot = [...state.whatsappBot, payload];
        }
    },
    setSelectedTemplateStatus: (state, { payload}) => {
        state.selectedTemplateStatus = payload.selectedTemplateStatus;
    }
  },
});

export const MetaTemplatesActions = metaTemplatesSlice.actions;
export default metaTemplatesSlice.reducer;
